import gql from 'graphql-tag'

export const threadAttrsFragment = gql`
  fragment threadAttrs on Thread {
    __typename
    id
    createdBy
    updatedAt
    noteId
    highlight
    activityCount
    lastActivityAt
    lastActivityBy
    resolvedAt
    createdAt
  }
`

export const commentAttrsFragment = gql`
  fragment commentAttrs on Comment {
    __typename
    id
    content
    entities
    threadId
    createdAt
    createdBy
    archivedAt
  }
`

export const threadAttrsWithCommentsFragment = gql`
  fragment threadAttrsWithComments on Thread {
    ...threadAttrs
    comments {
      ...commentAttrs
    }
  }
  ${threadAttrsFragment}
  ${commentAttrsFragment}
`

export const createThread = gql`
  mutation createThread($thread: ThreadCreationInput!) {
    createThread(thread: $thread) {
      ...threadAttrsWithComments
    }
  }
  ${threadAttrsWithCommentsFragment}
`

export const addCommentToThread = gql`
  mutation addCommentToThread($comment: CommentCreationInput!) {
    addCommentToThread(comment: $comment) {
      ...threadAttrsWithComments
    }
  }
  ${threadAttrsWithCommentsFragment}
`

export const resolveThread = gql`
  mutation resolveThread($threadId: ID!) {
    resolveThread(threadId: $threadId) {
      ...threadAttrs
    }
  }
  ${threadAttrsFragment}
`

export const unresolveThread = gql`
  mutation unresolveThread($threadId: ID!) {
    unresolveThread(threadId: $threadId) {
      ...threadAttrs
    }
  }
  ${threadAttrsFragment}
`

export const archiveComment = gql`
  mutation archiveComment($input: ArchiveCommentInput!) {
    archiveComment(input: $input) {
      ...commentAttrs
    }
  }
  ${commentAttrsFragment}
`

export const updateComment = gql`
  mutation updateComment($input: EditCommentInput!) {
    updateComment(input: $input) {
      ...commentAttrs
    }
  }
  ${commentAttrsFragment}
`

export const threadCreatedSubscription = gql`
  subscription threadCreated($noteId: ID!) {
    threadCreated(noteId: $noteId) {
      ...threadAttrsWithComments
    }
  }
  ${threadAttrsWithCommentsFragment}
`

export const threadUpdatedSubscription = gql`
  subscription threadUpdated($noteId: ID!) {
    threadUpdated(noteId: $noteId) {
      ...threadAttrsWithComments
    }
  }
  ${threadAttrsWithCommentsFragment}
`

export const threadArchivedSubscription = gql`
  subscription threadArchived($noteId: ID!) {
    threadArchived(noteId: $noteId) {
      threadId
    }
  }
`

export const commentAddedToThreadSubscription = gql`
  subscription commentAddedToThread($noteId: ID!) {
    commentAddedToThread(noteId: $noteId) {
      ...threadAttrsWithComments
    }
  }
  ${threadAttrsWithCommentsFragment}
`

export const commentUpdatedSubscription = gql`
  subscription commentUpdated($noteId: ID!) {
    commentUpdated(noteId: $noteId) {
      comment {
        ...commentAttrs
      }
    }
  }
  ${commentAttrsFragment}
`

export const commentArchivedSubscription = gql`
  subscription commentArchived($noteId: ID!) {
    commentArchived(noteId: $noteId) {
      commentId
    }
  }
`
